import React from "react";

const Other = ({ checkboxState, handleCheckboxChange }) => {
  return (
    <div>
      <div
        id="w-node-_6d8b0001-8e05-b4c7-f377-fb73d97d859c-1538e4e7"
        className="edit-profile-interest-option-div"
      >
        <div className="edit-profile-icon-wrapper intminheight">
          <div className="tabs-nav-icon w-embed">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 73 76"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_27_847)">
                <path
                  d="M40.3588 55.2951C49.4374 55.2951 56.7971 47.493 56.7971 37.8685C56.7971 28.2441 49.4374 20.442 40.3588 20.442C31.2802 20.442 23.9205 28.2441 23.9205 37.8685C23.9205 47.493 31.2802 55.2951 40.3588 55.2951Z"
                  fill="#E2B760"
                />
                <path
                  d="M1.68138 56.1119C1.38434 56.1119 1.0985 55.9552 0.947178 55.6811C0.330672 54.5622 0 53.3035 0 52.028V7.55245C0 3.39021 3.39639 0 7.56622 0H58.9885C61.051 0 63.0462 0.861538 64.4642 2.36084C64.7836 2.6965 64.7668 3.22797 64.4305 3.54685C64.0943 3.86573 63.5618 3.84895 63.2424 3.51329C62.1383 2.34965 60.5914 1.67832 58.9885 1.67832H7.56622C4.32115 1.67832 1.68138 4.31329 1.68138 7.55245V52.028C1.68138 53.0182 1.93359 53.9972 2.41559 54.8643C2.63977 55.2727 2.49405 55.7818 2.08491 56.0056C1.95601 56.0783 1.81589 56.1119 1.68138 56.1119Z"
                  fill="#000"
                />
                <path
                  d="M19.6161 76C19.5096 76 19.3976 75.9776 19.2967 75.9385C18.9828 75.8098 18.7754 75.5021 18.7754 75.1608V67.2727H14.0115C9.8417 67.2727 6.44531 63.8825 6.44531 59.7203V15.2448C6.44531 11.0825 9.8417 7.69231 14.0115 7.69231H65.4338C69.6036 7.69231 73 11.0825 73 15.2448V59.7203C73 63.8825 69.6036 67.2727 65.4338 67.2727H28.7068L20.2102 75.7538C20.0477 75.9161 19.8347 76 19.6161 76ZM14.0115 9.37063C10.7665 9.37063 8.12669 12.0056 8.12669 15.2448V59.7203C8.12669 62.9594 10.7665 65.5944 14.0115 65.5944H19.6161C20.0813 65.5944 20.4568 65.9692 20.4568 66.4336V73.1357L27.7652 65.8406C27.9222 65.6839 28.1351 65.5944 28.3593 65.5944H65.4338C68.6789 65.5944 71.3186 62.9594 71.3186 59.7203V15.2448C71.3186 12.0056 68.6789 9.37063 65.4338 9.37063H14.0115Z"
                  fill="#000"
                />
                <path
                  d="M39.7255 56.2014C29.385 56.2014 20.9725 47.8042 20.9725 37.4825C20.9725 27.1608 29.385 18.7636 39.7255 18.7636C50.066 18.7636 58.4785 27.1608 58.4785 37.4825C58.4785 47.8042 50.066 56.2014 39.7255 56.2014ZM39.7255 20.442C30.3154 20.442 22.6539 28.0839 22.6539 37.4825C22.6539 46.8811 30.3097 54.5231 39.7255 54.5231C49.1412 54.5231 56.7971 46.8811 56.7971 37.4825C56.7971 28.0839 49.1412 20.442 39.7255 20.442Z"
                  fill="#000"
                />
                <path
                  d="M35.3707 36.3916C34.9728 36.3916 34.6141 36.1063 34.5468 35.6979C34.3787 34.7636 33.5716 34.0923 32.6244 34.0923C31.6772 34.0923 30.8702 34.7692 30.702 35.6979C30.618 36.1567 30.1808 36.4587 29.7268 36.3748C29.2673 36.2909 28.9646 35.8601 29.0487 35.4014C29.3569 33.6671 30.8646 32.4084 32.6244 32.4084C34.3843 32.4084 35.8919 33.6671 36.2002 35.4014C36.2842 35.8601 35.976 36.2909 35.522 36.3748C35.4716 36.386 35.4211 36.386 35.3707 36.386V36.3916Z"
                  fill="#000"
                />
                <path
                  d="M49.5728 36.3916C49.1748 36.3916 48.8161 36.1063 48.7489 35.6979C48.5808 34.7636 47.7737 34.0923 46.8265 34.0923C45.8793 34.0923 45.0723 34.7692 44.9041 35.6979C44.8201 36.1567 44.3829 36.4587 43.9289 36.3748C43.4694 36.2909 43.1667 35.8601 43.2508 35.4014C43.559 33.6671 45.0667 32.4084 46.8265 32.4084C48.5864 32.4084 50.094 33.6671 50.4023 35.4014C50.4863 35.8601 50.1781 36.2909 49.7241 36.3748C49.6737 36.386 49.6232 36.386 49.5728 36.386V36.3916Z"
                  fill="#000"
                />
                <path
                  d="M39.7255 50.1315C35.012 50.1315 30.831 47.558 29.5644 43.8713C29.4635 43.5748 29.5363 43.2448 29.7549 43.0154C29.9735 42.786 30.3042 42.7021 30.6012 42.7916C33.1513 43.558 36.3964 43.9776 39.7255 43.9776C40.4093 43.9776 41.093 43.9608 41.76 43.9273C44.3661 43.793 46.8209 43.4014 48.8498 42.7916C49.1469 42.7021 49.4775 42.7916 49.6961 43.0154C49.9147 43.2448 49.9875 43.5748 49.8867 43.8713C49.2814 45.6336 48.0203 47.1664 46.2381 48.3021C44.3661 49.4993 42.1131 50.1315 39.7199 50.1315H39.7255ZM31.9519 44.8727C33.4876 47.0378 36.4412 48.4476 39.7199 48.4476C41.76 48.4476 43.7496 47.8937 45.3301 46.8867C46.2044 46.3273 46.9386 45.6392 47.4823 44.8727C45.7561 45.2532 43.8393 45.4993 41.8441 45.6C41.1491 45.6336 40.4317 45.656 39.7199 45.656C36.9793 45.656 34.289 45.3818 31.9519 44.8671V44.8727Z"
                  fill="#000"
                />
              </g>
              <defs>
                <clipPath id="clip0_27_847">
                  <rect width={73} height={76} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <label className="w-checkbox ms-pill-item">
          <input
            type="checkbox"
            name="checkbox-3"
            id="checkbox-3w"
            data-name="Checkbox 3"
            className="w-checkbox-input ms-pill-checkbox"
            checked={checkboxState.other}
            onChange={handleCheckboxChange("other")}
          />
          <span
            className="ms-pill-label has-icon w-form-label"
            htmlFor="checkbox-3"
          >
            Other
          </span>
          <div className="ms-pill-icon w-embed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="currentColor"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" />
            </svg>
          </div>
        </label>
      </div>
    </div>
  );
};

export default Other;
